<template>
  <v-app style="zoom: 90%;">
    <v-main>
      <div class="fixed-background"
          :style="{
            backgroundImage: `url(${isDark ? darkBg : lightBg})`
          }"
        ></div>
      <div class="main-content">
        <router-view />
      </div>
    </v-main>
  </v-app>
</template>

<script>

import { useTheme } from 'vuetify'
import { computed } from 'vue'
import lightBg from '/assets/img/bg-App.jpg'
import darkBg from '/assets/img/bg-App_dark.jpg'

export default {
  setup() {
    const theme = useTheme()
    const isDark = computed(() => theme.global.name.value === 'dark')

    return {
      isDark,
      lightBg,
      darkBg
    }
  }
}

</script>

<style scoped>
  .fixed-background {
    position: fixed;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    z-index: 0;
  }

  .main-content {
    position: relative;
    z-index: 1;
    min-height: 100vh;
    margin-top: 2px;
  }
</style>
  